import {
  RESET_NUMERICAL_PARAMETER,
  SET_KITCHEN_ISLAND_MEASUREMENTS,
  SET_WALL_PANEL_HEIGHT,
  SET_SHAPE_FIELD,
  SET_OVERHANG_FIELD,
} from 'domain/Options/constants';

const flagChanges = (state, action) => {
  switch (action.type) {
    case SET_SHAPE_FIELD:
    case SET_WALL_PANEL_HEIGHT:
    case SET_KITCHEN_ISLAND_MEASUREMENTS:
    case SET_OVERHANG_FIELD:
    case RESET_NUMERICAL_PARAMETER:
      return state.setIn(['plan', 'hasChanges'], true)
        .set('planCode', null);
    default:
      return state;
  }
};

export default flagChanges;
